export const MenuItemHeight = 48;
